<template>
  <div class="banner">
    <img class="banimg" src="../../public/image/banner4.png" alt />
    <div class="conbox" :class="{en_conbox:$i18n.locale=='en'}">
      <div class="text">
        <p class="title" :class="{fadeinup:fadeinup}" style="animation-delay: 0.2s">
          {{$t('home').pro.text0[0]}}
          <br /> {{$t('home').pro.text0[1]}}
        </p>
        <!-- <p class="con" :class="{fadeinup2:fadeinup,en_con:$i18n.locale=='en'}">
          Insist on providing high-quality refrigerants, general copper pipes for air-conditioning and heating, ventilation products,
          <br />air-conditioning accessories and insulation materials for global users.
        </p> -->
      </div>
      <div class="allItems" :class="{fadeinup3:fadeinup}">
        <div class="btn" @click="gotoTech(0)">
          <img src="../asset/aike/fu2.png" alt />
          <span> {{$t('home').pro.text1[0]}}</span>
        </div>
        <div class="btn"  @click="gotoTech(1)">
          <img src="../asset/aike/zlb.png" alt />
          <span>{{$t('home').pro.text1[1]}}</span>
        </div>
        <div class="btn"  @click="gotoTech(2)">
          <img src="../asset/aike/rbb.png" alt />
          <span>{{$t('home').pro.text1[2]}}</span>
        </div>
        <div class="btn"  @click="gotoTech(3)">
          <img src="../asset/aike/gdb.png" alt />
          <span>{{$t('home').pro.text1[3]}}</span>
        </div>
        <div class="btn"  @click="gotoTech(4)">
          <img src="../asset/aike/ywb.png" alt />
          <span>{{$t('home').pro.text1[4]}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "banner",
  data() {
    return {
      fadeinup: false,
    };
  },
  components: {},
  mounted() {},
  computed: {
    ...mapState(["shortMenu"]),
  },
  watch: {
    shortMenu(val) {
      if (val == "3" && !this.fadeinup) {
        this.fadeinup = true;
      }
    },
  },
  methods: {
    gotoTech(n){
       const link=`./tech.html?index=${n}`
      window.open(link,'_self')
    }
  },
};
</script>

<style lang="scss" scoped>
.btn img {
  height: 20px;
}
.banner {
  width: 100%;
  height: 100%;
  position: relative;
  .banimg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    z-index: 1;
    cursor: pointer;
    transform: scale(1);
    transition: all 5s;
  }
  .conbox {
    width: 80%;
    position: absolute;
    top: 33%;
    left: 50%;
    transform: translateX(-50%);
    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      p {
        text-align: center;
      }
      .title {
        font-size: 50px;
        font-family: "SOURCEHANSANSCN-LIGHT";
        // font-weight: lighter;
        color: #c1e5ff;
        line-height: 75px;
        text-shadow: 0 2px 2px #00000070;
      }
      .fadeinup {
        animation: fadeInUp 2000ms;
      }
      .fadeinup2 {
        animation: fadeInUp2 2000ms;
      }

      .con {
        margin-top: 20px;
        font-size: 16px;
        line-height: 40px;
        font-family: "it";
        color: #c1e5ff;
      }
    }
    @keyframes fadeInUp {
      from {
        transform: translateY(100px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
    @keyframes fadeInUp2 {
      from {
        transform: translateY(400px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
    @keyframes fadeInUp3 {
      from {
        transform: translateY(100px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
    .allItems {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      margin-top: 115px;
      .btn {
        margin: 5px;
        padding: 10px 40px;
        display: flex;
        align-items: center;
        padding: 15px 40px;
        border: 1px solid #0090ff;
        background-color: #0091ff49;
        transition: all 300ms;
        cursor: pointer;
        position: relative;
        transition: all 600ms;
        &::after {
          position: absolute;
          top: 0;
          left: 0;
          display: inline-block;
          content: "";
          background-color: #138ee0;
          width: 0;
          height: 100%;
          transition: all 600ms;
          z-index: -1;
        }
        &:hover {
          &::after {
            width: 100%;
          }
        }
        span {
          font-size: 16px;
          font-family: "SOURCEHANSANSCN-LIGHT";
          margin-left: 10px;
          color: #c1e5ff;
        }
      }
    }
    .fadeinup3 {
      animation: fadeInUp3 2000ms;
    }
  }
}
@media screen and (max-width:1000px) {
  .banner{
    .conbox{
      width: 95%;
      top: 20%;
      .text{
        .title{
          font-size: 18px;
          line-height: 30px;
        }
        .con{
          line-height: 30px;
        }
        .en_con{
          display: none;
        }
      }
      .allItems{
        margin-top: 30px;
        flex-wrap: wrap;
        .btn{
          width: calc(47% - 20px);
          padding: 10px;
          margin: 1%;
          span{
            font-size: 14px;
          }
        }
      }
    }
    .en_conbox{
      top: 20%;
      .allItems{
        .btn{
          width: 80%;
        }
      }
    }
  }
}
</style>
